import React, { useState, useEffect } from 'react';
import { TailSpin } from 'react-loader-spinner';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { useTeamColors } from 'hooks';
import { color as themeColors } from 'theme';

const Wrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: -1;
  top: 0;
  left: 0;
  pointer-events: none;
  opacity: ${(props) => (props.$show ? 1 : 0)};
  transition: opacity 0.2s ease-in-out;
`;

const LoaderContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
`;

export const Loading = () => {
  const { mainColor, isTeamSite } = useTeamColors();
  const configLoading = useSelector((state) => state.configuration?.loading);
  const [showLoader, setShowLoader] = useState(false);

  // Only show loader if loading takes longer than 300ms
  // This prevents flickering for fast loads
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowLoader(true);
    }, 300);

    return () => clearTimeout(timer);
  }, []);

  // Use neutral color during initial config load, then switch to team color
  const spinnerColor =
    configLoading && !isTeamSite ? themeColors.lightGrey : mainColor;

  return (
    <Wrapper $show={showLoader}>
      <LoaderContainer>
        <TailSpin color={spinnerColor} height={100} width={100} />
      </LoaderContainer>
    </Wrapper>
  );
};
